import { LocalizationProvider, deDE } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';

import { useEffect, useState } from 'react';
import StorylineServerProxy from '../storyline-proxy/storyline-proxy';
import { Button, CircularProgress, Grid, Link, Modal, Paper } from '@mui/material';
import TEDDetails from './TED-details';

function TEDsList({ title, TEDs }){

    let [detailsOpen, setDetailsOpen] = useState(false);
    let [selectedTED, setSelectedTED] = useState(null as any);

    function handleCloseDetails(){
        setDetailsOpen(false);
    }

    function handleCloseAndDelete(){
        setDetailsOpen(false);
    }

    function handleTEDClicked(TED){
        setSelectedTED(TED);
        setDetailsOpen(true);
    }

    return (
        <>

        <Modal sx={{ left: 100, top: 100, width:9/10, }} open={detailsOpen} onClose={handleCloseDetails}>
            <Paper elevation={6} sx={{padding: 2}}>
                <TEDDetails ted={selectedTED} handleCloseAndDelete={handleCloseAndDelete} handleClose={handleCloseDetails}/>
            </Paper>
        </Modal>


        <Paper elevation={6} sx={{ padding: 2}}>
            <h2>{title}</h2>
            { TEDs.length } TEDs
            <br/><br/>
            { 
                TEDs.map(TED => {
                    return(
                        <>
                            <Link onClick={() => {handleTEDClicked(TED)}}>{ TED.title }</Link>
                            <br/><br/>
                        </>
                    )
                })
            }
        </Paper>
        </>
    )
}

export default function TEDsDownloadPage(){

    let [selectedDate, setSelectedDate] = useState(dayjs(new Date()));
    let [noticeNumber, setNoticeNumber] = useState(null as number | null);
    let [downloadDone, setDownloadDone] = useState(false);
    let [downloadInProgress, setDownloadInProgress] = useState(false);
    let [processingInProgress, setProcessingInProgress] = useState(false);
    let [existingTEDs, setExistingTEDs] = useState([] as any[]);
    let [newTEDs, setNewTEDs] = useState([] as any[]);

    function checkStatusOnServer(){
        StorylineServerProxy.noticeForDate(selectedDate.year(), selectedDate.month() + 1, selectedDate.date()).then(result => {
            setNoticeNumber(result.notice && result.notice.number);
            setDownloadDone(result.downloadDone);
        });
    }

    useEffect(() => {
        checkStatusOnServer();
    }, [selectedDate])

    function handleDownloadClicked(){
        setDownloadInProgress(true);
        StorylineServerProxy.downloadForDate(selectedDate.year(), selectedDate.month() + 1, selectedDate.date()).then(() => {
            setDownloadInProgress(false);
            checkStatusOnServer();
        })
    }

    function handleProcessClicked(){
        setProcessingInProgress(true);
        setNewTEDs([]);
        setExistingTEDs([]);
        StorylineServerProxy.processForDate(selectedDate.year(), selectedDate.month() + 1, selectedDate.date()).then((TEDs) => {
            setProcessingInProgress(false);
            setExistingTEDs(TEDs.existingTEDs);
            setNewTEDs(TEDs.newTEDs);
        });
    }

    return (
    <>
        <Paper elevation={6} sx={{ padding: 2 }}>
            <Grid container>
                <Grid item xs={6}>
                    <p align="center"><h2>Date selector</h2></p>
                    
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='en-gb'>
                        <DateCalendar value={selectedDate} onChange={(newDate) => setSelectedDate(newDate!)}/>
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={6}>
                    <p align="center">
                        <h2>Processing control</h2>
                        <br/>
                        { !noticeNumber && <>No notice</>}
                        { noticeNumber && <>Notice number: { noticeNumber } </>}
                        {
                            downloadInProgress?<CircularProgress />:
                            <>
                                {
                                    noticeNumber && <><br/><Button variant="contained" onClick={handleDownloadClicked}>Download</Button></>
                                }
                                <br/><br/>
                                {
                                    noticeNumber && (downloadDone?(
                                        <>Donwload done<br/>
                                        {
                                            processingInProgress?<CircularProgress/>:<Button onClick={handleProcessClicked}>Process</Button>
                                        }
                                    </>):"Not downloaded yet"
                                )}
                            </>
                        }
                    </p>
                </Grid>
            </Grid>

        </Paper>
        <TEDsList title="Existing TEDs" TEDs={existingTEDs} />
        <TEDsList title="New TEDs" TEDs={newTEDs} />
    </>)
}